const initialState = () => {
    return {
        /**
         * @description
         * Here you should declare the state properties and it's initial values
         */
        currentList: null,
        model: null,
        pagination: null,
    }
}

export default initialState
